import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import * as OptionLabelsActions from './option-labels.actions';

import { DataAccessSearchService } from '../../service/data-access-search.service';

@Injectable()
export class OptionLabelsEffects {
  initStaticLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OptionLabelsActions.loadOptionLabels),
      withLatestFrom(this.searchService.getStaticFilterLabels()),
      map(([_action, staticLabels]) => OptionLabelsActions.loadOptionLabelsSuccess({ optionLabels: staticLabels }))
    )
  );

  initTopicLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OptionLabelsActions.loadOptionLabels),
      withLatestFrom(this.fairsFacade.fairId$),
      switchMap(([_action, fairId]) =>
        this.searchService
          .getTopicLabels(fairId)
          .pipe(map((topicLabels) => OptionLabelsActions.loadOptionLabelsSuccess({ optionLabels: topicLabels })))
      )
    )
  );

  initProductGroupLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OptionLabelsActions.loadOptionLabels),
      withLatestFrom(this.fairsFacade.fairId$),
      switchMap(([_action, fairId]) =>
        this.searchService
          .getProductGroupLabels(fairId)
          .pipe(
            map((productGroupLabels) =>
              OptionLabelsActions.loadOptionLabelsSuccess({ optionLabels: productGroupLabels })
            )
          )
      )
    )
  );

  initProfessionLabels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OptionLabelsActions.loadOptionLabels),
      withLatestFrom(this.fairsFacade.fairId$),
      switchMap(([_action, fairId]) =>
        this.searchService
          .getProfessionLabels(fairId)
          .pipe(
            map((professionLabels) => OptionLabelsActions.loadOptionLabelsSuccess({ optionLabels: professionLabels }))
          )
      )
    )
  );

  initExhibitorLabel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OptionLabelsActions.loadExhibitorFilterLabel),
      withLatestFrom(this.fairsFacade.fairId$),
      switchMap(([action, fairId]) =>
        this.searchService
          .getExhibitorFilterLabel(action.exhibitorId, fairId)
          .pipe(
            map((exhibitorFilterLabel) =>
              OptionLabelsActions.loadOptionLabelsSuccess({ optionLabels: [exhibitorFilterLabel] })
            )
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private searchService: DataAccessSearchService,
    private fairsFacade: DataAccessFairsFacade
  ) {}
}
